export const getAllEventsReducer = (
  state = { events: [], loading: false },
  action
) => {
  switch (action.type) {
    case "GETING_ALL_EVENTS":
      return { ...state, loading: true };
    case "GOT_ALL_EVENTS":
      return { ...state, loading: false, events: action.payload };
    case "CANNOT_GET_ALL_EVENTS":
      return { ...state, loading: false };
    default:
      return state;
  }
};


export const getSingleEventsReducer = (
  state = { singleEvent: [], loading: false },
  action
) => {
  switch (action.type) {
    case "GETING_SINGLE_EVENT":
      return { ...state, loading: true };
    case "GOT_SINGLE_EVENTS":
      return { ...state, loading: false, singleEvent: action.payload };
    case "CANNOT_GET_SINGLE_EVENTS":
      return { ...state, loading: false };
    default:
      return state;
  }
};